import { Component, ViewEncapsulation, input, ChangeDetectionStrategy } from '@angular/core';
import { CurrencyIsoCode } from '@coin/shared/core/util-models';
import { DisplayedCurrency } from '@coin/shared/core/util-enums';
import { RecordAchievementDto } from '@coin/shared/incentive/util';
import { SafeHtmlPipe, ThousandsSeparatorPipe } from '@coin/shared/core/util-pipes';
import { PercentPipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'coin-incentive-record-achievement-table',
  templateUrl: './record-achievement-table.component.html',
  styleUrls: ['./record-achievement-table.component.scss'],
  imports: [ThousandsSeparatorPipe, PercentPipe, SafeHtmlPipe],
  encapsulation: ViewEncapsulation.None
})
export class RecordAchievementTableComponent {
  tableData = input<RecordAchievementDto | null>();
  currency = input<CurrencyIsoCode>(DisplayedCurrency.EUR);
  isLocalCurrency = input(false);
  dynamicContentHtml = input<string | null>();
  isPreview = input<boolean>(false);

  public get isPrintTable(): boolean {
    return !!this.dynamicContentHtml && !this.isPreview;
  }

  private get ippTargetSplitAchievement(): number {
    return this.tableData()?.ippAchievementValue * (this.tableData()?.ippSplit / 100) || 0;
  }

  public get overallTargetAchievement(): number {
    return this.ippTargetSplitAchievement + this.tableData()?.unitTargetAchievement;
  }

  public get hasIpp(): boolean {
    return !!this.tableData()?.ippAchievementValue || !!this.tableData()?.ippSplit;
  }
  public get hasFactor(): boolean {
    return this.tableData()?.factorValue > 0;
  }
}
